import React, { useState, Fragment, useMemo, useEffect } from 'react';

import { usePageColors } from '../../hooks';
import { StepIcon } from './StepIcon';
import StepContext from './StepContext';

import styles from './StepSwitch.scss';

function StepSwitch({ children }) {
    const [currentStep, setCurrentStep] = useState(1);
    const [steps, setSteps] = useState(() =>
        React.Children.toArray(children).map((child, index) => {
            const number = index + 1;
            return {
                number,
                name: child.props.name,
                icon: child.props.icon,
                child,
                isDone: number < currentStep,
                isCurrent: currentStep === number,
            };
        })
    );
    const colors = usePageColors();
    const style = useMemo(
        () => ({
            divider: { backgroundColor: colors.color },
            step: { backgroundColor: colors.backgroundColor, borderColor: colors.backgroundColor, color: colors.color },
            stepCurrent: {
                backgroundColor: colors.color,
                borderColor: colors.color,
                color: colors.backgroundColor,
            },
        }),
        [colors]
    );

    useEffect(() => {
        setSteps((old) =>
            old.map((step) => ({
                ...step,
                isCurrent: step.number === currentStep,
                isDone: step.isDone || currentStep > step.number,
            }))
        );
    }, [currentStep]);

    const content = steps.find((step) => step.isCurrent).child;

    return (
        <StepContext.Provider value={{ currentStep, setCurrentStep, steps }}>
            <div>
                <ul className={styles.nav}>
                    {steps.map((step) => (
                        <Fragment key={step.number}>
                            {step.number !== 1 && <li className={styles.divider} style={style.divider} />}

                            <StepIcon style={style} step={step} />
                        </Fragment>
                    ))}
                </ul>
                <div>{content}</div>
            </div>
        </StepContext.Provider>
    );
}

export default StepSwitch;
